import React, { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';
import { FiPlus } from 'react-icons/fi';
import { FeatureList } from './Feature';

interface FeatureConfigureModalProps {
    isOpen: boolean;
    type: "usage-limits" | "feature-list";
    mode: string;
    editItemId: string;
    dataList: FeatureList[];
    setMode: React.Dispatch<React.SetStateAction<string>>;
    setData: (data: FormDataInterface[]) => void;
    onClose: () => void;
    setDataList: React.Dispatch<React.SetStateAction<FeatureList[]>>
}

interface FormDataInterface {
    id: string;
    feature: string;
    unit: string;
    cost: string;
}

const FeatureConfigureModal: React.FC<FeatureConfigureModalProps> = ({ isOpen, mode, editItemId, dataList, setMode, type, setData, onClose,setDataList }) => {
    const [formData, setFormData] = useState<FormDataInterface>(
        {
            id: Math.random().toString(36).substring(2, 9),
            feature: "",
            unit: "",
            cost: ""
        }
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev: FormDataInterface) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if(mode === "add"){
            setData([formData]);
        }else{
            setDataList((prev) => prev.map((i) => i.id === editItemId?formData:i));
        }
        onClose();
    };

    useEffect(() => {
        if (mode === "edit") {

            const dataToEdit = dataList.find((i) => i.id === editItemId);
            console.log("datatoedit =>>>>>", dataToEdit);
            if(!dataToEdit) return;
            setFormData({
                id: dataToEdit.id,
                feature: dataToEdit.feature,
                unit: dataToEdit.unit,
                cost: dataToEdit.cost,
            });

        }
    }, [isOpen]);

    return (
        <Dialog.Root open={isOpen} onOpenChange={onClose}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
                <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] max-h-[70vh]">
                    <BorderGradient className='rounded-lg flex flex-col h-full w-full'>
                        <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full">
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-4 text-gray-400 hover:text-white"
                            >
                                <FiPlus size={24} className="rotate-45" />
                            </button>


                            <h2 className="text-xl font-semibold mb-6 text-white"> {mode === "edit"?"Edit":"Add"} {type === "feature-list" ? "Configuration" : "Usage limits"}</h2>

                            <form onSubmit={handleSubmit}>


                                <div>
                                    <label className="block text-sm text-gray-400 mb-1">Feature</label>
                                    <select
                                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        name="feature"
                                        value={formData.feature}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selet Feature</option>
                                        <option value="users">Users</option>
                                        <option value="storage">Storage</option>
                                    </select>
                                </div>

                                <div className='mt-5'>
                                    <label className="block text-sm text-gray-400 mb-1">Unit</label>
                                    <select
                                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        name="unit"
                                        value={formData.unit}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selet Unit</option>
                                        <option value="Number">Number</option>
                                        <option value="GB">GB</option>
                                    </select>
                                </div>

                                <div className='mt-5'>
                                    <label className="block text-sm text-gray-400 mb-1">Cost</label>
                                    <input
                                        type="text"
                                        className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
                                        placeholder="Enter discount code"
                                        name="cost"
                                        value={formData.cost}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="flex justify-end pt-4">
                                    <button
                                        className="flex items-center justify-center text-center gap-2 px-4 py-2 w-[140px] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                        type="button"
                                        onClick={onClose}
                                        >
                                        Cancel
                                    </button>

                                    <button
                                        type="submit"
                                        className="flex items-cente justify-center gap-2 px-4 py-2 w-[140px] bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>
                        </div>

                    </BorderGradient>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default FeatureConfigureModal;
